// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ia-0";
export var headerCellHover = "_ia-1";
export var readCellContainer = "_ia-2";
export var unreadIndicator = "_ia-3";